<template>
    <div>
        <div class="container">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
                        <a href="#">首頁</a>
                    </router-link>
                    <router-link :to="{ name: 'Other' }" tag="li" class="breadcrumb-item">
                        <a href="#">其他資訊</a>
                    </router-link>
                    <li class="breadcrumb-item">
                        {{ $t('UnitBirthday') }} </li>
                </ol>
            </nav>
            <div class="item-box">
                <h3 class="item-title">
                    {{ $t('UnitBirthday') }}  Calendar
                </h3>
                <div id="calendar"></div>
            </div>
            <div class="item-box mt-3">
                <h3 class="item-title">
                    {{ $t('UnitBirthday') }} 
                </h3>
                <div class="row">
                    <div class="" v-for="item in profile">
                        <div class="m-2 c-box anm-float">
                            <div class="card-deck">
                                <div class="card">
                                    <img class="img-fluid" :src="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" alt="" />
                                    <div class="card-footer text-center">
                                        <small class="text-muted d-block">{{ item.kana }}</small>
                                        <small class="text-muted d-block">{{ item.profile.birth_month }} / {{ item.profile.birth_day }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import unit_profile from "../../assets/edata/unit_profile.txt";
import moment from "moment";
import "moment-timezone";
import axios from "axios";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import twLocale from "@fullcalendar/core/locales/zh-tw";
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
export default {
    name: "Birthday",
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: "角色生日",
        // all titles will be injected into this template
        titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
        meta: [{ name: "description", content: "超異域公主連結☆Re:Dive 的主角滿等經驗試算" }],
    },
    data() {
        return {
            unitProfile: {},
            unit_list: [],
        };
    },
    created: function() {},
    computed: {
        profile: function() {
            return this.unit_list;
        },
    },
    methods: {
        cut: function(name) {},
    },
    mounted: function() {
        var self = this;
        var unitProfile = JSON.parse(self.atou(unit_profile));
        _.find(unitProfile, ["unit_id", "101401"]).age = "15";
        _.find(unitProfile, ["unit_id", "112201"]).age = "15";
        _.find(unitProfile, ["unit_id", "110001"]).age = "17";
        _.find(unitProfile, ["unit_id", "101601"]).age = "17";
        _.find(unitProfile, ["unit_id", "101701"]).age = "17";
        _.find(unitProfile, ["unit_id", "110501"]).age = "17";
        _.find(unitProfile, ["unit_id", "105201"]).age = "17";
        _.find(unitProfile, ["unit_id", "115801"]).age = "17";
        _.find(unitProfile, ["unit_id", "105301"]).age = "17";
        _.find(unitProfile, ["unit_id", "114201"]).age = "17";
        _.find(unitProfile, ["unit_id", "107901"]).age = "19";
        _.find(unitProfile, ["unit_id", "104601"]).age = "19";
        var self = this;
        var unit_data = self.$store.getters.getUnitData;
        var actualUnits = self.$store.getters.getCharaIdentity;
        var filter = this.filter;
        var list = new Array();
        _.forEach(unit_data, function(value) {
            _.forEach(actualUnits, function(o) {
                if (o.unit_id == _.toInteger(value.unit_id) && value.cutin_1 != "0") {
                    var profile = _.find(unitProfile, ["unit_id", value.unit_id]);
                    o["rarity"] = value.rarity;
                    o["kana"] = value.unit_name;
                    o["profile"] = profile;
                    o["birthday"] = moment("2024/" + profile.birth_month + "/" + profile.birth_day).format("YYYY/MM/DD");
                    o["birthday_next"] = moment("2025/" + profile.birth_month + "/" + profile.birth_day).format("YYYY/MM/DD");
                    list.push(o);
                }
            });
        });
        list = _.sortBy(list, function(dateObj) {
            return dateObj.birthday;
        });
        this.unit_list = list;
        var calendarEvent = new Array();
        _.forEach(list, function(o) {
            var obj = {};
            var typeClass = "";
            try {
                obj["title"] = o.kana;
                obj["start"] = new Date(o.birthday).toISOString();
                obj["end"] = new Date(o.birthday).toISOString();
                obj["classNames"] = "fc-event-item e1";
                calendarEvent.push(obj);
            } catch {}
        });

        _.forEach(list, function(o) {
            var obj = {};
            var typeClass = "";
            try {
                obj["title"] = o.kana;
                obj["start"] = new Date(o.birthday_next).toISOString();
                obj["end"] = new Date(o.birthday_next).toISOString();
                obj["classNames"] = "fc-event-item e1";
                calendarEvent.push(obj);
            } catch {}
        });
        var calendarEl = document.getElementById("calendar");
        var calendar = new Calendar(calendarEl, {
            plugins: [dayGridPlugin],
            locale: "zh-tw",
            eventSources: [
                {
                    events: calendarEvent,
                },
            ],
            eventLimit: false, // for all non-TimeGrid views
            contentHeight: "auto",
        });
        calendar.render();
        calendar.updateSize();
    },
};
</script>
<style scoped>
small {
    margin-left: 5px;
}
</style>
